import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { CustomMaterialModule } from '@app/core/material.module';
import { ButtonComponent } from '../component/button.component';

@NgModule({
    declarations: [ButtonComponent],
    exports: [ButtonComponent],
    imports: [CustomMaterialModule, CommonModule, GlobalModule],
})
export class ButtonModule {}
